export default __webpack_public_path__ + "static/media/09_photo.806a0500.jpg";